/**
 * API Configuration
 */

// REST API (Beta)
export const API_BASE_URL = 'https://thaliak.xiv.dev/api/v2beta';
// export const API_BASE_URL = 'http://localhost:8080';
